import React, { ButtonHTMLAttributes } from 'react'
import styled, { css } from 'styled-components'
import { Spinner } from '../Spinner'

const StyledButton = styled.button<Props>`
  cursor: pointer;
  padding: 12px 24px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: var(--default-text);
  font-weight: 700;
  /* border-radius: 18px; */
  white-space: nowrap;

  svg:first-child {
    margin-right: 0.5em;
  }
`

const PrimaryButton = styled(StyledButton)`
  color: ${({ theme }) => theme.colors.font.white};
  background-color: ${({ theme }) => theme.colors.button.primary};
  border: none;
  border: 1px solid ${({ theme }) => theme.colors.button.primary};

  &:hover,
  &:focus {
    /* TODO: Make this lighter */
    color: ${({ theme }) => theme.colors.font.inverse};
    /* background-color: ${({ theme }) => theme.colors.brand.primary.hover}; */
    /* border: 1px solid ${({ theme }) => theme.colors.brand.primary.hover}; */
  }

  /* &:active {
    background-color: ${({ theme }) => theme.colors.brand.primary.active};
    border: 1px solid ${({ theme }) => theme.colors.brand.primary.active};
  } */

  ${(props) =>
    props.disabled &&
    css`
      color: ${({ theme }) => theme.colors.font.disabled};
      background-color: ${({ theme }) =>
        theme.colors.system.interactive.disabled};
      border: 1px solid
        ${({ theme }) => theme.colors.system.interactive.disabled};
      cursor: default;

      &:hover,
      &:focus {
        background-color: ${({ theme }) =>
          theme.colors.system.interactive.disabled};
        border: 1px solid
          ${({ theme }) => theme.colors.system.interactive.disabled};
      }
    `}
`

const SecondaryButton = styled(StyledButton)`
  color: ${({ theme }) => theme.colors.font.regular};
  background-color: ${({ theme }) => theme.colors.button.secondary};
  border: 1px solid ${({ theme }) => theme.colors.button.secondaryBorder};

  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.colors.brand.secondary.hover};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.brand.secondary.active};
  }

  ${(props) =>
    props.disabled &&
    css`
      color: ${({ theme }) => theme.colors.font.disabled};
      background-color: ${({ theme }) =>
        theme.colors.system.interactive.disabled};
      border: 1px solid
        ${({ theme }) => theme.colors.system.interactive.disabled};
      cursor: default;

      &:hover,
      &:focus {
        background-color: ${({ theme }) =>
          theme.colors.system.interactive.disabled};
      }
    `}
`
const WarningButton = styled(StyledButton)`
  color: ${({ theme }) => theme.colors.font.regular};
  background-color: ${({ theme }) => theme.colors.system.critical.border};
  border: 1px solid ${({ theme }) => theme.colors.system.critical.border};

  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.colors.system.critical.regular};
    border: 1px solid ${({ theme }) => theme.colors.system.critical.regular};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.system.critical.regular};
    border: 1px solid ${({ theme }) => theme.colors.system.critical.regular};
  }

  ${(props) =>
    props.disabled &&
    css`
      color: ${({ theme }) => theme.colors.font.disabled};
      background-color: ${({ theme }) =>
        theme.colors.system.interactive.disabled};
      border: 1px solid
        ${({ theme }) => theme.colors.system.interactive.disabled};
      cursor: default;

      &:hover,
      &:focus {
        background-color: ${({ theme }) =>
          theme.colors.system.interactive.disabled};
      }
    `}
`

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  kind?: 'primary' | 'secondary' | 'warning'
  link?: string
  loading?: boolean
  loadingChild?: React.ReactNode
}

export const Button: React.FC<Props> = (props) => {
  const {
    children,
    className,
    kind = 'primary',
    loading,
    loadingChild,
    ...rest
  } = props

  switch (kind) {
    case 'primary':
      return (
        <PrimaryButton className={className} {...rest}>
          {loading ? <Spinner /> : null}
          {loading && loadingChild ? loadingChild : children}
        </PrimaryButton>
      )
    case 'secondary':
      return (
        <SecondaryButton className={className} {...rest}>
          {loading ? <Spinner /> : null}
          {loading && loadingChild ? loadingChild : children}
        </SecondaryButton>
      )
    case 'warning':
      return (
        <WarningButton className={className} {...rest}>
          {loading ? <Spinner /> : null}
          {loading && loadingChild ? loadingChild : children}
        </WarningButton>
      )
  }
}
